import {
  GiChopsticks,
  GiIndianPalace,
  // GiTropicalFish,
  GiCamel,
  GiHighKick,
} from "react-icons/gi";
import styled from "styled-components";
import { NavLink } from "react-router-dom"; // alot of people use 'Link"

function Category() {
  return (
    <List>
      <SLink to={"/cuisine/Japanese"}>
        <GiChopsticks />
        <h4>Japanese</h4>
      </SLink>
      <SLink to={"/cuisine/middle eastern"}>
        <GiCamel />
        <h4>Middle Eastern</h4>
      </SLink>
      <SLink to={"/cuisine/Indian"}>
        <GiIndianPalace />
        <h4>Indian</h4>
      </SLink>
      <SLink to={"/cuisine/Chinese"}>
        <GiHighKick />
        <h4>Chinese</h4>
      </SLink>
    </List>
  );
}

const List = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 2rem 0rem;
`;

// Slink is specifically for NAVLINKS
// This is the design for the links on the top
const SLink = styled(NavLink)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 50%;
  margin-right: 2rem;
  text-decoration: none;
  /* background: linear-gradient(35deg, #494949, #313131); */
  background-color: #333;
  width: 6rem;
  height: 6rem;
  cursor: pointer;
  transform: scale(0.8);

  h4 {
    color: white;
    font-size: 0.8rem;
    text-align: center;
  }

  svg {
    color: white;
    font-size: 1.5rem;
  }
  &.active {
    /* We adding an active class to it */
    background: linear-gradient(to right, #f27121, #e94057);

    svg {
      color: white;
    }
    h4 {
      color: white;
    }
  }
`;

export default Category;

// import { FaPizzaSlice } from "react-icons/fa";
// import { MdOutlineRamenDining } from "react-icons/md";

// {/* <SLink className="italian" to={"/cuisine/Italian"}>
//         <FaPizzaSlice />
//         <h4>Italian</h4>
//       </SLink> */}
//       {/* <SLink className="korean" to={"/cuisine/Korean"}>
//         <MdOutlineRamenDining />
//         <h4>Korean</h4>
//       </SLink> */}
//       {/* <SLink className="mediterranean" to={"/cuisine/Mediterranean"}>
//         <GiTropicalFish />
//         <h4>Mediterranean</h4>
//       </SLink> */}
